import React, { useState } from 'react';
import { XIcon, CheckIcon, ChevronRightIcon, ChevronLeftIcon, BuildingIcon, MailIcon, PhoneIcon, MapPinIcon, AwardIcon } from 'lucide-react';
interface OnboardPartnerModalProps {
  isOpen: boolean;
  onClose: () => void;
}
const STEPS = [{
  id: 1,
  title: 'Basic Info'
}, {
  id: 2,
  title: 'Tier Assignment'
}, {
  id: 3,
  title: 'Guidelines'
}, {
  id: 4,
  title: 'Complete'
}];
export function OnboardPartnerModal({
  isOpen,
  onClose
}: OnboardPartnerModalProps) {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    location: '',
    email: '',
    phone: '',
    tier: 'Silver',
    guidelinesAccepted: false
  });
  if (!isOpen) return null;
  const handleNext = () => {
    if (currentStep < STEPS.length) {
      setCurrentStep(currentStep + 1);
    } else {
      onClose();
    }
  };
  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  return <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm animate-in fade-in duration-200" onClick={onClose} data-id="element-710">
      <div className="bg-white w-full max-w-xl rounded-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300" onClick={e => e.stopPropagation()} data-id="element-711">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between bg-gray-50" data-id="element-712">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-713">
            Onboard New Partner
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-200 rounded-full transition-colors text-gray-500" data-id="element-714">
            <XIcon size={20} data-id="element-715" />
          </button>
        </div>

        {/* Step Indicator */}
        <div className="px-8 py-6" data-id="element-716">
          <div className="flex items-center justify-between relative" data-id="element-717">
            <div className="absolute left-0 top-1/2 transform -translate-y-1/2 w-full h-0.5 bg-gray-200 -z-10" data-id="element-718"></div>
            <div className="absolute left-0 top-1/2 transform -translate-y-1/2 h-0.5 bg-blue-600 -z-10 transition-all duration-300" style={{
            width: `${(currentStep - 1) / (STEPS.length - 1) * 100}%`
          }} data-id="element-719"></div>

            {STEPS.map(step => {
            const isCompleted = step.id < currentStep;
            const isActive = step.id === currentStep;
            return <div key={step.id} className="flex flex-col items-center bg-white px-2" data-id="element-720">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-colors duration-300 ${isCompleted ? 'bg-green-500 text-white' : isActive ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-721">
                    {isCompleted ? <CheckIcon size={16} data-id="element-722" /> : step.id}
                  </div>
                  <span className={`text-xs mt-2 font-medium ${isActive ? 'text-blue-600' : 'text-gray-500'}`} data-id="element-723">
                    {step.title}
                  </span>
                </div>;
          })}
          </div>
        </div>

        {/* Content */}
        <div className="px-8 py-4 min-h-[300px]" data-id="element-724">
          {currentStep === 1 && <div className="space-y-4 animate-in slide-in-from-right-4 duration-300" data-id="element-725">
              <div data-id="element-726">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-727">
                  Partner Name
                </label>
                <div className="relative" data-id="element-728">
                  <BuildingIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} data-id="element-729" />
                  <input type="text" className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="e.g. Mumbai Motors" value={formData.name} onChange={e => setFormData({
                ...formData,
                name: e.target.value
              })} data-id="element-730" />
                </div>
              </div>
              <div data-id="element-731">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-732">
                  Location
                </label>
                <div className="relative" data-id="element-733">
                  <MapPinIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} data-id="element-734" />
                  <input type="text" className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="City, State" value={formData.location} onChange={e => setFormData({
                ...formData,
                location: e.target.value
              })} data-id="element-735" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-736">
                <div data-id="element-737">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-738">
                    Email
                  </label>
                  <div className="relative" data-id="element-739">
                    <MailIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} data-id="element-740" />
                    <input type="email" className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="contact@dealer.com" value={formData.email} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} data-id="element-741" />
                  </div>
                </div>
                <div data-id="element-742">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-743">
                    Phone
                  </label>
                  <div className="relative" data-id="element-744">
                    <PhoneIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} data-id="element-745" />
                    <input type="tel" className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="+91 98765 43210" value={formData.phone} onChange={e => setFormData({
                  ...formData,
                  phone: e.target.value
                })} data-id="element-746" />
                  </div>
                </div>
              </div>
            </div>}

          {currentStep === 2 && <div className="space-y-4 animate-in slide-in-from-right-4 duration-300" data-id="element-747">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-748">
                Assign Partner Tier
              </label>
              <div className="grid grid-cols-1 gap-3" data-id="element-749">
                {['Platinum', 'Gold', 'Silver', 'Bronze'].map(tier => <label key={tier} className={`flex items-center p-4 border rounded-xl cursor-pointer transition-all ${formData.tier === tier ? 'border-blue-500 bg-blue-50 ring-1 ring-blue-500' : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'}`} data-id="element-750">
                    <input type="radio" name="tier" className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" checked={formData.tier === tier} onChange={() => setFormData({
                ...formData,
                tier
              })} data-id="element-751" />
                    <div className="ml-4 flex-1" data-id="element-752">
                      <div className="flex items-center justify-between" data-id="element-753">
                        <span className="font-medium text-gray-900 flex items-center gap-2" data-id="element-754">
                          <AwardIcon size={16} className={tier === 'Platinum' ? 'text-purple-600' : tier === 'Gold' ? 'text-amber-500' : tier === 'Silver' ? 'text-gray-500' : 'text-orange-600'} data-id="element-755" />
                          {tier} Tier
                        </span>
                        {formData.tier === tier && <CheckIcon size={16} className="text-blue-600" data-id="element-756" />}
                      </div>
                    </div>
                  </label>)}
              </div>
            </div>}

          {currentStep === 3 && <div className="space-y-6 animate-in slide-in-from-right-4 duration-300" data-id="element-757">
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-758">
                <h3 className="font-semibold text-gray-900 mb-2" data-id="element-759">
                  Brand Guidelines Agreement
                </h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed" data-id="element-760">
                  By onboarding this partner, you confirm that they have
                  received the brand guidelines documentation and agree to
                  adhere to all compliance policies regarding creative usage,
                  messaging, and pricing.
                </p>
                <ul className="text-sm text-gray-600 space-y-2 mb-4 list-disc pl-4" data-id="element-761">
                  <li data-id="element-762">Adhere to logo usage policies</li>
                  <li data-id="element-763">Follow pricing and offer guidelines</li>
                  <li data-id="element-764">Use approved creative assets only</li>
                  <li data-id="element-765">Maintain brand tone of voice</li>
                </ul>
              </div>

              <label className="flex items-start gap-3 p-4 border border-gray-200 rounded-xl cursor-pointer hover:bg-gray-50 transition-colors" data-id="element-766">
                <input type="checkbox" className="w-5 h-5 text-blue-600 rounded border-gray-300 mt-0.5" checked={formData.guidelinesAccepted} onChange={e => setFormData({
              ...formData,
              guidelinesAccepted: e.target.checked
            })} data-id="element-767" />
                <div data-id="element-768">
                  <span className="font-medium text-gray-900" data-id="element-769">
                    I acknowledge and agree
                  </span>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-770">
                    Partner has signed the brand compliance agreement.
                  </p>
                </div>
              </label>
            </div>}

          {currentStep === 4 && <div className="flex flex-col items-center justify-center h-full text-center animate-in zoom-in-95 duration-300 py-8" data-id="element-771">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-772">
                <CheckIcon size={40} className="text-green-600" data-id="element-773" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-774">
                Partner Onboarded!
              </h3>
              <p className="text-gray-500 max-w-xs mx-auto mb-8" data-id="element-775">
                <span className="font-semibold text-gray-900" data-id="element-776">
                  {formData.name}
                </span>{' '}
                has been successfully added to the network as a{' '}
                <span className="font-semibold text-blue-600" data-id="element-777">
                  {formData.tier}
                </span>{' '}
                partner.
              </p>
              <div className="flex gap-3" data-id="element-778">
                <button className="px-6 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50" data-id="element-779">
                  View Profile
                </button>
                <button className="px-6 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700" data-id="element-780">
                  Send Welcome Kit
                </button>
              </div>
            </div>}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 flex justify-between items-center" data-id="element-781">
          <button onClick={handleBack} className={`flex items-center px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors ${currentStep === 1 || currentStep === 4 ? 'invisible' : ''}`} data-id="element-782">
            <ChevronLeftIcon size={16} className="mr-1" data-id="element-783" />
            Back
          </button>

          {currentStep !== 4 && <div className="flex gap-3" data-id="element-784">
              <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-200 rounded-lg transition-colors" data-id="element-785">
                Cancel
              </button>
              <button onClick={handleNext} disabled={currentStep === 3 && !formData.guidelinesAccepted} className="flex items-center px-6 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 shadow-sm transition-all transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-786">
                {currentStep === 3 ? 'Complete Onboarding' : 'Next Step'}
                <ChevronRightIcon size={16} className="ml-1" data-id="element-787" />
              </button>
            </div>}

          {currentStep === 4 && <button onClick={onClose} className="ml-auto px-6 py-2 bg-gray-900 text-white rounded-lg text-sm font-medium hover:bg-gray-800 shadow-sm" data-id="element-788">
              Close
            </button>}
        </div>
      </div>
    </div>;
}